module.exports = {
  OWNER: 'owner',
  ADMIN: 'admin',
  EDITOR: 'editor',
  VIEWER: 'viewer',
  INSTRUCTOR: 'instructor',
}
